module.exports = __webpack_public_path__ + "img/orange_011.5e8f2dde.png";